import { TemplateCta, TemplateFooter, TemplateMeta } from './TemplateParts';

export default function DigitalInviteMaison({ data }) {
  const {
    artTypeLabel,
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-6 md:p-7 flex flex-col justify-center">
      <div className="mx-auto w-full max-w-[92%] rounded-[30px] border border-[#E8D6C7] bg-[#FFF9F4]/90 shadow-[0_24px_52px_rgba(54,37,28,0.2)] p-6 md:p-8 flex flex-col text-center min-h-[72%]">
        <div className="mx-auto mb-3 h-[1px] w-14 bg-[#A8845E]/55" />

        <div className="flex items-center justify-center gap-2">
          <span className="text-[#7A5E4A]/90 text-[11px] tracking-[0.24em] uppercase font-semibold">{artTypeLabel}</span>
          {isPremium ? (
            <span className="rounded-full px-2 py-0.5 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#FFF4E5] text-[#9C784C]">
              Premium
            </span>
          ) : null}
        </div>

        <h4 className="mt-4 text-[2.15rem] md:text-[2.75rem] font-bold leading-[1.06]" style={titleStyle}>
          {coupleName}
        </h4>

        <div className="mt-5">
          <TemplateMeta rows={rows} centered textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} uppercase />
        </div>

        {shortPhrase ? (
          <p className="mt-5 text-sm md:text-base max-w-[88%] mx-auto" style={bodyStyle.style}>
            {shortPhrase}
          </p>
        ) : null}

        {ctaText ? (
          <div className="mt-4">
            <TemplateCta text={ctaText} textColor={textColor} textShadow={textShadow} mode="signature" center />
          </div>
        ) : null}

        <div className="mt-6 mx-auto h-[1px] w-20 bg-[#A8845E]/35" />

        <TemplateFooter
          showSiteLink={showSiteLink}
          siteUrl={siteUrl}
          showQrCode={showQrCode}
          textColor={textColor}
          accentColor={accentColor}
          centered
        />
      </div>
    </div>
  );
}
